// Indica si la exportación terminó con archivo, sin registros o con error.
export const isTerminalExportSnapshot = (snapshot) =>
  ['done', 'empty', 'error'].includes(snapshot?.status)

/**
 * Selecciona el estado más reciente recibido por HTTP o socket, sin reabrir una
 * exportación finalizada ni retroceder las filas procesadas dentro de la misma etapa.
 */
export function newestExportSnapshot(current, incoming) {
  if (!incoming || isTerminalExportSnapshot(current)) return current
  if (!current || isTerminalExportSnapshot(incoming)) return incoming
  const previousTime = Date.parse(current.updated_at)
  const incomingTime = Date.parse(incoming.updated_at)
  if (Number.isFinite(previousTime) && Number.isFinite(incomingTime)) {
    if (previousTime > incomingTime) return current
    if (previousTime === incomingTime) {
      // Compara las fracciones de segundo con precisión adicional a los milisegundos de Date.parse.
      const fraction = (text) =>
        (text.match(/\.(\d+)(?:Z|[+-]\d{2}:\d{2})$/)?.[1] || '').padEnd(9, '0')
      if (fraction(current.updated_at) >= fraction(incoming.updated_at)) return current
    }
  }
  if (current.stage === incoming.stage && current.processed_rows > incoming.processed_rows)
    return current
  return incoming
}

// Comprueba si el navegador indica conexión; si no existe navigator, asume que hay conexión.
export const exportIsOnline = () => typeof navigator === 'undefined' || navigator.onLine !== false

/**
 * Espera a recuperar la conexión: devuelve true al conectar y false al agotar
 * el tiempo de espera en milisegundos. Si se cancela la señal, rechaza con AbortError.
 */
export function waitForExportOnline(signal, timeout) {
  signal.throwIfAborted()
  if (exportIsOnline()) return Promise.resolve(true)
  // Coordina la reconexión, la cancelación y el vencimiento de la espera.
  return new Promise((resolve, reject) => {
    // Retira el temporizador y los listeners cuando termina la espera.
    const cleanup = () => {
      clearTimeout(timer)
      window.removeEventListener('online', online)
      signal.removeEventListener('abort', abort)
    }
    // Finaliza la espera al recibir el evento de conexión del navegador.
    const online = () => {
      cleanup()
      resolve(true)
    }
    // Cancela la espera y comunica la cancelación a quien llamó la función.
    const abort = () => {
      cleanup()
      reject(new DOMException('Aborted', 'AbortError'))
    }
    const timer = setTimeout(
      // Finaliza sin conexión cuando vence el tiempo permitido.
      () => {
        cleanup()
        resolve(false)
      },
      Math.max(0, timeout)
    )
    window.addEventListener('online', online, { once: true })
    signal.addEventListener('abort', abort, { once: true })
  })
}
